/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import './App.css';

import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom"

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import defaultTheme from './theme/theme';

import {
  COMMON_URLS,
  EQUIPMENT_URL_PREFIX,
  EQUIPMENT_URLS,
  HAND_SELECTION_URL_PREFIX,
  HAND_SELECTION_URLS,
  WORK_URL_PREFIX,
  WORK_URLS,
  SYSTEM_URL_PREFIX,
  SYSTEM_URLS,
  OPERATING_ENVIRONMENT_URL_PREFIX,
  OPERATING_ENVIRONMENT_URLS,
  OPERATING_TEST_URL_PREFIX, OPERATING_TEST_URLS,
  TRAJECTORY_URL_PREFIX, TRAJECTORY_URLS
} from './constants/constants'

import configureAmplify from "./utils/awsConfigure";
import {setAuthLanguage, authFormFields, authComponents} from "./utils/authCustomization";

import ScrollToTop from './utils/ScrollTop';

import MainLayout from './templates/MainLayout';
import EquipmentLayout from './features/equipmentdb/templates/EquipmentLayout';
import WorkLayout from "./features/workdb/templates/WorkLayout";
import SystemLayout from './features/systemdb/templates/SystemLayout';
import TrajectoryLayout from './features/trajectorydb/templates/TrajectoryLayout';
import Top from './pages/Top'
import Faq from './pages/Faq'
import HandList from './features/equipmentdb/pages/HandList';
import HandDetail from './features/equipmentdb/pages/HandDetail';
import FingertipList from './features/equipmentdb/pages/FingertipList';
import FingertipDetail from './features/equipmentdb/pages/FingertipDetail';
import ArmList from './features/equipmentdb/pages/ArmList';
import ArmDetail from './features/equipmentdb/pages/ArmDetail';
import AttachmentList from './features/equipmentdb/pages/AttachmentList';
import AttachmentDetail from './features/equipmentdb/pages/AttachmentDetail';
import EquipmentRegiste from './features/equipmentdb/pages/EquipmentRegiste';
import WorkList from './features/workdb/pages/WorkList';
import WorkDetail from './features/workdb/pages/WorkDetail';
import WorkRegister from "./features/workdb/pages/WorkRegister";
import WorkRegisteredList from "./features/workdb/pages/WorkRegisteredList";
import SystemList from './features/systemdb/pages/SystemList';
import SystemDetail from './features/systemdb/pages/SystemDetail';
import SystemRegiste from './features/systemdb/pages/SystemRegiste';
import TrajectoryRegiste from './features/trajectorydb/pages/TrajectoryRegiste';
import TrajectoryResult from './features/trajectorydb/pages/TrajectoryResult';
import NotFound from './pages/NotFound';
import HandSelectionLayout from "./features/handselection/templates/HandSelectionLayout";
import WorkSelection from "./features/handselection/pages/WorkSelection";
import CalculatedList from "./features/handselection/pages/CalculatedList";
import OperatingEnvironmentLayout from "./features/operatingEnvironment/templates/OperatingEnvironmentLayout";
import ObjectList from "./features/operatingEnvironment/pages/ObjectList";
import WorldList from "./features/operatingEnvironment/pages/WorldList";
import ObjectDetail from "./features/operatingEnvironment/pages/ObjectDetail";
import WorldDetail from "./features/operatingEnvironment/pages/WorldDetail";
import OperatingEnvironmentRegister from "./features/operatingEnvironment/pages/Register";
import Simulation from "./features/operatingTest/pages/Simulation";
import OperatingTestLayout from "./features/operatingTest/templates/OperatingTestLayout";

configureAmplify();
setAuthLanguage();

function App() {

  return (
    <>
      <ToastContainer />
      <Authenticator hideSignUp formFields={authFormFields} components={authComponents}>
        {({ signOut, user }) => (
          <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <Router>
              <ScrollToTop />
              <Routes>
                <Route path='/' element={<MainLayout bgcolor='#F6F7F8'/>}>
                  <Route index element={<Top />} />
                  <Route path={String(COMMON_URLS.FAQ.URL)} element={<Faq />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
                <Route path={String(EQUIPMENT_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(EQUIPMENT_URLS.HAND_LIST.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<HandList/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.HAND_DETAIL.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<HandDetail/>} />
                  </Route>
                  <Route path={`${EQUIPMENT_URLS.HAND_DETAIL.URL}/:${EQUIPMENT_URLS.HAND_DETAIL.ARG}`} element={<EquipmentLayout/>}>
                    <Route index element={<HandDetail/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.FINGERTIP_LIST.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<FingertipList/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.FINGERTIP_DETAIL.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<FingertipDetail/>} />
                  </Route>
                  <Route path={`${EQUIPMENT_URLS.FINGERTIP_DETAIL.URL}/:${EQUIPMENT_URLS.FINGERTIP_DETAIL.ARG}`} element={<EquipmentLayout/>}>
                    <Route index element={<FingertipDetail/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.ARM_LIST.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<ArmList/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.ARM_DETAIL.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<ArmDetail/>} />
                  </Route>
                  <Route path={`${EQUIPMENT_URLS.ARM_DETAIL.URL}/:${EQUIPMENT_URLS.ARM_DETAIL.ARG}`} element={<EquipmentLayout/>}>
                    <Route index element={<ArmDetail/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.ATTACHMENT_LIST.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<AttachmentList/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.ATTACHMENT_DETAIL.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<AttachmentDetail/>} />
                  </Route>
                  <Route path={`${EQUIPMENT_URLS.ATTACHMENT_DETAIL.URL}/:${EQUIPMENT_URLS.ATTACHMENT_DETAIL.ARG}`} element={<EquipmentLayout/>}>
                    <Route index element={<AttachmentDetail/>} />
                  </Route>
                  <Route path={String(EQUIPMENT_URLS.REGISTE.URL)} element={<EquipmentLayout/>}>
                    <Route index element={<EquipmentRegiste/>} />
                  </Route>
                  <Route path={`${EQUIPMENT_URLS.REGISTE.URL}/:${EQUIPMENT_URLS.REGISTE.ARG_MODE}/:${EQUIPMENT_URLS.REGISTE.ARG_ID}`} element={<EquipmentLayout/>}>
                    <Route index element={<EquipmentRegiste/>} />
                  </Route>
                </Route>
                <Route path={String(WORK_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(WORK_URLS.WORK_LIST.URL)} element={<WorkLayout/>}>
                    <Route index element={<WorkList/>} />
                  </Route>
                  <Route path={String(WORK_URLS.WORK_DETAIL.URL)} element={<WorkLayout/>}>
                    <Route index element={<WorkDetail/>} />
                  </Route>
                  <Route  path={`${WORK_URLS.WORK_DETAIL.URL}/:${WORK_URLS.WORK_DETAIL.ARG_CLASS_ID}`} element={<WorkLayout/>}>
                    <Route index element={<WorkDetail/>} />
                  </Route>
                  <Route path={String(WORK_URLS.WORK_REGISTER.URL)} element={<WorkLayout/>}>
                    <Route index element={<WorkRegister/>} />
                  </Route>
                  <Route path={String(WORK_URLS.WORK_REGISTER_LIST.URL)} element={<WorkLayout/>}>
                    <Route index element={<WorkRegisteredList/>} />
                  </Route>
                </Route>
                <Route path={String(SYSTEM_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(SYSTEM_URLS.SYSTEM_LIST.URL)} element={<SystemLayout/>}>
                    <Route index element={<SystemList/>} />
                  </Route>
                  <Route path={String(SYSTEM_URLS.SYSTEM_DETAIL.URL)} element={<SystemLayout/>}>
                    <Route index element={<SystemDetail/>} />
                  </Route>
                  <Route path={`${SYSTEM_URLS.SYSTEM_DETAIL.URL}/:${SYSTEM_URLS.SYSTEM_DETAIL.ARG}`} element={<SystemLayout/>}>
                    <Route index element={<SystemDetail/>} />
                  </Route>
                  <Route path={String(SYSTEM_URLS.REGISTE.URL)} element={<SystemLayout/>}>
                    <Route index element={<SystemRegiste/>} />
                  </Route>
                  <Route path={`${SYSTEM_URLS.REGISTE.URL}/:${SYSTEM_URLS.REGISTE.ARG_MODE}/:${SYSTEM_URLS.REGISTE.ARG_ID}`} element={<SystemLayout/>}>
                    <Route index element={<SystemRegiste/>} />
                  </Route>
                </Route>
                <Route path={String(HAND_SELECTION_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(HAND_SELECTION_URLS.BEGINNING_WORK.URL)} element={<HandSelectionLayout/>}>
                    <Route index element={<WorkSelection/>} />
                  </Route>
                  <Route path={String(HAND_SELECTION_URLS.BEGINNING_HAND.URL)} element={<HandSelectionLayout/>}>
                    <Route index element={<CalculatedList/>} />
                  </Route>
                </Route>
                <Route path={String(OPERATING_ENVIRONMENT_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(OPERATING_ENVIRONMENT_URLS.OBJECT_LIST.URL)} element={<OperatingEnvironmentLayout/>}>
                    <Route index element={<ObjectList/>} />
                  </Route>
                  <Route path={`${OPERATING_ENVIRONMENT_URLS.OBJECT_DETAIL.URL}/:${OPERATING_ENVIRONMENT_URLS.OBJECT_DETAIL.ARG}?`} element={<OperatingEnvironmentLayout/>}>
                    <Route index element={<ObjectDetail/>} />
                  </Route>
                  <Route path={String(OPERATING_ENVIRONMENT_URLS.WORLD_LIST.URL)} element={<OperatingEnvironmentLayout/>}>
                    <Route index element={<WorldList/>} />
                  </Route>
                  <Route path={`${OPERATING_ENVIRONMENT_URLS.WORLD_DETAIL.URL}/:${OPERATING_ENVIRONMENT_URLS.WORLD_DETAIL.ARG}?`} element={<OperatingEnvironmentLayout/>}>
                    <Route index element={<WorldDetail/>} />
                  </Route>
                  <Route path={`${OPERATING_ENVIRONMENT_URLS.REGISTER.URL}`} element={<OperatingEnvironmentLayout/>}>
                    <Route index element={<OperatingEnvironmentRegister />} />
                  </Route>
                </Route>
                <Route path={String(OPERATING_TEST_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(OPERATING_TEST_URLS.SIMULATION.URL)} element={<OperatingTestLayout/>}>
                    <Route index element={<Simulation/>} />
                  </Route>
                </Route>
                <Route path={String(TRAJECTORY_URL_PREFIX)} element={<MainLayout />}>
                  <Route path={String(TRAJECTORY_URLS.TRAJECTORY_REGISTE.URL)} element={<TrajectoryLayout/>}>
                    <Route index element={<TrajectoryRegiste/>} />
                  </Route>
                  <Route path={String(TRAJECTORY_URLS.TRAJECTORY_RESULT.URL)} element={<TrajectoryLayout/>}>
                    <Route index element={<TrajectoryResult/>} />
                  </Route>
                </Route>
              </Routes>
            </Router>

          </ThemeProvider>
        )}
      </Authenticator>
    </>
  );
}

export default App;
